import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ngbd-side-nav',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
